//import props section
import React from 'react'
import { useDispatch } from 'react-redux'
import propTypes from 'prop-types'
//import material ui section
import { Typography, Stepper, Step, StepLabel, Button, Paper, makeStyles, Divider } from '@material-ui/core'
//import components section
import SideBar from '../../common/DashboadSideBar'
import { Layout, Content, Header, HeaderBreadCrum } from '../../layouts/AuthenticatedLayout'
import AddSerieStep from './step1/AddSerieStepComponent'
import ServiceChecklists from './step2/ServiceChecklists'
import CreateServiceStep from './step3/CreateService'
import { updateServiceActualStep } from '../../../store/services/serviceActions'
import iconSparePart from '../../../resources/images/sparePart.svg'
import ToolbarComponent from '../../common/Toolbar'

const steps = ['Add Series', 'Service Checklist', 'Create Service']

const DesktopView = (props) => {
	const classes = DesktopStyles()
	const {
		userProfile,
		token,
		currentStep,
		setCurrentStep,
		selectedSerie,
		// checklistData, 
		// setChecklistData 
	} = props
	//Functions props section
	const { onAddSeries, onChangeLocation, onDeleteSerieFromService, onChecklistResponse, onSetChecklistApplicability } = props
	//object props section
	const { service, checklists } = props
	//string props section

	//arrays props section

	//bool props section
	const { isSaving } = props
	const dispatch = useDispatch()

	const navigateToStep = (stepIndex) => {
		// if (stepIndex === 2 && !serie && !selectedSerie) return
		// if (stepIndex === 3 && (!checklistData || !selectedSerie)) return
		// if (serie) setSelectedSerie(serie)
		setCurrentStep(stepIndex)
	}

	const updateActualStepInBackend = async (stepIndex) => {
		try {
			if (token) await dispatch(updateServiceActualStep(token, stepIndex))
		} catch (error) {
			console.error('Error actualizando ActualStep:', error)
		}
	}

	const handleSaveProgress = async () => {
		try {
			await updateActualStepInBackend(currentStep)
		} catch (error) {
			console.error('Error en handleSaveProgress:', error)
		}
	}

	// const handlePrevStep = () => {
	// 	// Simplemente ir al paso anterior
	// 	if (currentStep > 1) {
	// 		setCurrentStep(currentStep - 1)
	// 	}
	// }

	// const clearState = () => {
	// 	setCurrentStep(1)
	// 	// setAddedSeries([])
	// 	// setSelectedSerie(null)
	// 	setChecklistData(null)
	// 	updateActualStepInBackend(1)
	// }

	const renderContent = () => {
		const stepComponents = {
			1: (
				<AddSerieStep
					//Functions props section
					onAddSeries={onAddSeries}
					onDeleteSerieFromService={onDeleteSerieFromService}
					service={service}
					//bool props
					isSaving={isSaving}
				/>
			),
			2: (
				<ServiceChecklists
					//bool props
					canBeAddedResponse={true}
					isVisibleMessageChecklisAppicable={true}
					isSaving={isSaving}
					//objects props
					checklists={checklists}
					service={service}
					//functions props
					onChecklistResponse={onChecklistResponse}
					onSetChecklistApplicability={onSetChecklistApplicability}
				/>
			),
			3: (
				<div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', minHeight: '200px' }}>
					<CreateServiceStep
						//objects
						service={service}
					/>
				</div>
			)
		}
		return stepComponents[currentStep] || stepComponents[1]
	}

	const getBreadcrumb = () => {
		if (currentStep === 1) return 'Possible Services / Add Series'
		if (currentStep === 2 && selectedSerie) return `Possible Services / Service Checklist - ${selectedSerie.Serie}`
		if (currentStep === 3 && selectedSerie) return `Possible Services / Create Service - ${selectedSerie.Serie}`
		return `Possible Services / ${steps[currentStep - 1]}`
	}

	// const isStepClickable = (index) => {
	// 	return (
	// 		(index === 0 && currentStep >= 1) || (index === 1 && selectedSerie && currentStep >= 2) || (index === 2 && checklistData && selectedSerie)
	// 	)
	// }

	const buttonConfig = {
		1: {
			text: selectedSerie ? `Continuar con ${selectedSerie.Serie}` : 'Selecciona una Serie',
			// disabled: !selectedSerie,
			onClick: () => navigateToStep(2),
			secondary: true
		},
		2: { text: 'Save Checklist', onClick: handleSaveProgress },
		3: { text: 'Save Service', onClick: handleSaveProgress }
	}

	// No renderizar nada hasta que termine la carga inicial
	// if (currentStep === null || !initialLoadComplete) {
	// 	return null
	// }

	console.log('currentStep=>>>>>>>>>>>>>>>>>>>>>>>>>>', currentStep)
	return (
		<Layout>
			<Header
				key={'AuthenticatedHeader'}
				breadcrumbs={
					<HeaderBreadCrum>
						<Typography color='secondary'>{getBreadcrumb()}</Typography>
					</HeaderBreadCrum>
				}
			/>
			<SideBar key={'AuthenticatedSideBar'} onChangeLocation={onChangeLocation} selectedButtonIndex={12} userProfile={userProfile} />
			<Content key={'AuthenticatedContent'}>
				<Paper className={classes.root}>
					<ToolbarComponent title='Create service' icon={iconSparePart} />
					{/* <Paper className={classes.paperSearch}></Paper> */}

					{/* {currentStep !== 1 && (
						<Button variant='outlined' color='primary' onClick={handlePrevStep} size='small'>
							← Back
						</Button>
					)} */}
					<Stepper
						activeStep={currentStep - 1}
						alternativeLabel
						style={{
							flex: 1,
							margin: currentStep === 1 ? '0' : '0 20px',
							padding: 5 // ✅ Sin padding
						}}
					>
						{steps.map((label, index) => (
							<Step key={label}>
								<StepLabel
									onClick={() => navigateToStep(index + 1)}
									// onClick={() => isStepClickable(index) && navigateToStep(index + 1)}
									style={{ opacity: 1 }}
								// style={{ cursor: isStepClickable(index) ? 'pointer' : 'default', opacity: isStepClickable(index) ? 1 : 0.5 }}
								>
									{label}
								</StepLabel>
							</Step>
						))}
					</Stepper>
					<Divider style={{ margin: '12px 0' }} />

					<div style={{ padding: '0 12px' }}>{renderContent()}</div>

					{buttonConfig[currentStep] && (
						<div>
							{currentStep && currentStep > 1 && currentStep <= 3 && (
								<Button
									variant='contained'
									color={'primary'}
									// onClick={buttonConfig[currentStep].onClick}
									onClick={() => navigateToStep(currentStep - 1)}
									// disabled={buttonConfig[currentStep].disabled}
									size='small'
								>
									Back
								</Button>
							)}
							{currentStep && currentStep >= 1 && currentStep <= 2 && (
								<Button
									variant='contained'
									color='primary'
									onClick={() => navigateToStep(currentStep + 1)}

								// onClick={handleSaveProgress} size='small'
								>
									Next
								</Button>
							)}
						</div>
					)}
				</Paper>
			</Content>
		</Layout>
	)
}

export const DesktopStyles = makeStyles((theme) => ({
	root: {
		maxWidth: theme.views.maxWidth,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '10px',
		overflowY: 'auto',
		maxHeight: `calc(100vh - ${85}px)`
	},
	paperSearch: {
		padding: '20px',
		overflowY: 'auto',
		'& .MuiFormLabel-root': {
			color: theme.palette.text.primary
		}
	},
	textExpanded: {
		color: theme.palette.colors.purple
	},
	rootList: {},
	avatar: {
		width: 40,
		height: 40,
		borderRadius: 8
	},
	textSectionTitle: {
		fontWeight: 'bold', // Título en negrita
		fontSize: '1.1rem', // Tamaño de fuente un poco mayor
		color: theme.palette.colors.purple,
		marginLeft: '1rem'
	},
	sectionTitle: {
		borderRadius: '8px'
	},
	imagesSection: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '1rem'
	}
}))

DesktopView.propTypes = {
	onChangeLocation: propTypes.func.isRequired,
	userProfile: propTypes.object,
	service: propTypes.object,
	token: propTypes.string,
	currentStep: propTypes.number,
	setCurrentStep: propTypes.func.isRequired,
	addedSeries: propTypes.array.isRequired,
	setAddedSeries: propTypes.func.isRequired,
	selectedSerie: propTypes.object,
	setSelectedSerie: propTypes.func.isRequired,
	checklistData: propTypes.object,
	setChecklistData: propTypes.func.isRequired,
	initialLoadComplete: propTypes.bool.isRequired
}

DesktopView.defaultProps = {
	onChangeLocation: () => console.warn('Callback [onChangeLocation] no defined'),
	userProfile: null,
	service: null,
	token: null,
	currentStep: null,
	selectedSerie: null,
	checklistData: null
}

export default DesktopView
